export const getFirstChar = (str: string) => str.charAt(0)
